import { render } from "./schmetterlingseffekt.vue?vue&type=template&id=3808077a"
import script from "./schmetterlingseffekt.vue?vue&type=script&lang=js"
export * from "./schmetterlingseffekt.vue?vue&type=script&lang=js"

import "./schmetterlingseffekt.vue?vue&type=style&index=0&id=3808077a&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__